import React, {useContext, useEffect, useState} from "react";
import {DataContext, RealmContext, TokenContext} from "../../Store";
import {trackPromise} from "react-promise-tracker";
import LoadingIndicator from "../../../shared/LoadingIndicator";

import {makeStyles} from "@mui/styles";
import DatacomponentTableView from "./DatacomponentTableView";
import http from "../../../shared/http-common";
import UserService from "../../../services/UserService";
import {useNavigate} from "react-router-dom";

// Style für DataTreeView
const useStyles = makeStyles({
    root: {
        textAlign: "left",
        fontFamily: "poppins",
    },
    lightButton: {
        float: "right",
        fontWeight: "bold",
    },
    darkButton: {
        float: "right",
        color: "#e5e5e5",
        fontWeight: "bold",
    },
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },

    table: {
        minWidth: 700,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

const GetObjectDataByType = async (objecttype, type, realm, token) => {
    try {
        if(token && token !== 'Kein Token generiert!') {
            let formData = new FormData();
            formData.append("realm", realm);
            return await http.post(`/` + objecttype + `/` + type + `/list`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });
        }
    } catch (e) {
        console.error(e);
    }
};


function Datacomponents() {
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);

    const dataCtx = useContext(DataContext);
    const dataObjects = dataCtx.objects;
    const setDataObjects = dataCtx.setObjects;
    const Datacomponents = dataCtx.components;
    const setDatacomponents = dataCtx.setComponents;
    const [administrativeObjects, setAdministrativeObjects] = useState([]);
    let navigate = useNavigate();

    const classes = useStyles();

    useEffect(()=>{
        if(!UserService.isLoggedIn()) {
            UserService.doLogout();
            navigate('/')
        }
    }, []);

    useEffect(()=>{
        async function fetchData() {
            const dataObjects2 = await getMyData('realestateobject', 'site', realm, token);
            const administrativeObjects2 = await getMyData('administrativeobject', 'economicunit', realm, token);
            setDataObjects(dataObjects2);
            setAdministrativeObjects(administrativeObjects2);
        }
        fetchData();
    }, [realm, token, setDataObjects]);

    const getMyData = async (objecttype, type, realm, token) => {
        const result = await GetObjectDataByType(objecttype, type, realm, token);
        return result?.data;
    }

    return (
        <div>
            <div className={classes.katalogView}>
                <LoadingIndicator/>
                <div className={classes.btListe}>

                        <DatacomponentTableView
                            dataComponents={Datacomponents}
                            setDatacomponents={setDatacomponents}
                            realm={realm}
                            token={token}
                            dataObjects={dataObjects}
                            administrativeObjects={administrativeObjects}
                        />

                </div>

            </div>

        </div>
    );
}

export default Datacomponents;
